// extracted by mini-css-extract-plugin
export default {"loyaltyMask":"qH4TwR_NRm8PWrf0YsrJ"};